(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-n-deal"]) return;
  try {
    
  $( document ).ready(function() {
     window.setTimeout(startCount,2000);
  }); 

  function startCount(){
	startaction();
}

$(document).ready(function() {
              var owl = $('#owlcaraosel1');
              owl.owlCarousel({
                margin: 10,
                nav: true,
                loop: true,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 2
                  },
                  1000: {
                    items:2
                  }
                }
              })
            })
          

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"]) return;
  try {
    
$( document ).ready(function() {
     $('.maps iframe').css("pointer-events", "none"); 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured_product"]) return;
  try {
    
$(document).ready(function() {
              var owl = $('#owlcaraosel3');
              owl.owlCarousel({
                margin: 10,
                nav: true,
                loop: true,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 3
                  },
                  1000: {
                    items:4
                  }
                }
              })
            })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featuredcat"]) return;
  try {
    
$(document).ready(function() {
              var owl = $('#owlcaraosel2');
              owl.owlCarousel({
                margin: 10,
                nav: true,
                loop: true,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 3
                  },
                  1000: {
                    items:3
                  }
                }
              })
            })

  } catch(e) { console.error(e); }
})();
})();
